import { useEffect, useState } from "react";

const WeatherWidget = () => {
    const [weather, setWeather] = useState(null);

    useEffect(() => {
        fetch(
            "https://api.openweathermap.org/data/2.5/forecast?q=Cairns,AU&units=metric&lang=ja&appid=b7c54866d771d6ef66babf1870265fee"
        )
            .then((res) => res.json())
            .then((data) => {
                if (!data.list) return;

                const today = new Date().toISOString().split("T")[0];

                const todayForecasts = data.list.filter((item) =>
                    item.dt_txt.startsWith(today)
                );

                if (todayForecasts.length === 0) return;

                const minTemp = Math.min(
                    ...todayForecasts.map((item) => item.main.temp_min)
                );

                const maxTemp = Math.max(
                    ...todayForecasts.map((item) => item.main.temp_max)
                );

                const current = todayForecasts[0];

                setWeather({
                    minTemp,
                    maxTemp,
                    description: current.weather[0].description,
                    icon: current.weather[0].icon,
                });
            });
    }, []);

    if (!weather) {
        return <div>Loading weather...</div>;
    }

    const iconUrl = `https://openweathermap.org/img/wn/${weather.icon}@2x.png`;

    return (
        <div
            title={weather.description}
            style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
            }}
        >
            {/*<img*/}
            {/*    src={iconUrl}*/}
            {/*    alt={weather.description}*/}
            {/*    width={40}*/}
            {/*    height={40}*/}
            {/*/>*/}

            <span>
                  {Number(weather.minTemp).toFixed(1)}°C /{" "}
                {Number(weather.maxTemp).toFixed(1)}°C
            </span>
        </div>
    );
};

export default WeatherWidget;